import React from 'react';
import { Navigate,  createHashRouter, RouterProvider } from "react-router-dom";
import SignIn, {SignInAction, SignInLoader} from './client/SignIn';
import CreateAccount from './client/CreateAccount';
import SignUp, { SignUpLoader } from './client/SignUp';
import ResetPassword, { ResetPasswordLoader } from './client/ResetPassword';
import ChangePassword from './client/ChangePassword';
import Dashboard from './components/dashboard/Dashboard';
import {useStore} from './hooks/useStore';
import ProtectedRoute from './components/ProtectedRoutes';
import Error from './components/Error';
import { useAuth } from './hooks/useAuth';
import SendOtp from './client/SendOtp';
import IdleTimerWithPrompt from './components/IdleTimerWithPrompt';
import Account, {AccountLoader} from './client/Account';
import Schedule, {ScheduleLoader} from './client/Schedule';
import HomeIcon from '@mui/icons-material/Home';
import PeopleIcon from '@mui/icons-material/People';



/**
 * A map of the fully expanded urls created in the browser code above to 
 * be used by the application in place of the actual urls.
 * E.g.   <Link href={Routes.signIn} >
 */
const Routes = {
    signIn: "/client/signIn",
    signUp: "/client/signUp",
    createAccount: "/client/createAccount",
    sendOtp: "/client/sendOtp",
    resetPassword: "/client/resetPassword",
    account: "/secureClient/account",
    schedule: "/secureClient/schedule",
    changePassword: "/secureClient/changePassword",
};


const mainMenuItems = [
  { text: 'Home', icon: HomeIcon, to: Routes.schedule },
  { text: 'Account', icon: PeopleIcon, to: Routes.account },
];


const AppRouter = () => { 
	
	const store = useStore();
	const auth = useAuth();
	
	const routeDefinitions = [
		{
            path: "/",
            errorElement: < Error / > ,
            element:<Navigate to="client/SignIn" replace />
        },		
        {
            path: "client",
            errorElement: < Error / > ,
			children: [
				{
                    path: "signIn",
                    errorElement: < Error / > ,
                    children: [
						{
		                    index:true,
		                    action: SignInAction(auth, store),	
		                    loader: SignInLoader,
		                    element: < SignIn / > ,				
		                },
						{
		                    path: ":companyName",
		                    action: SignInAction(auth, store),	
		                    loader: SignInLoader,
		                    element: < SignIn / > ,				
		                }				
					]
                },
                {
					loader: SignUpLoader,					
                    path: "signUp/:companyName",
                    element: < SignUp / > ,
                },
                {
					loader: SignUpLoader,					
                    path: "signUp",
                    element: < SignUp / > ,
                },
                {
                    path: "sendOtp",
                    element: < SendOtp / > ,
                },
                {				
                    path: "createAccount",
                    element: < CreateAccount / > ,
                },
                {
					loader: ResetPasswordLoader,		
                    path: "resetPassword/:companyName",
                    element: < ResetPassword / > ,
                },
                {
					loader: ResetPasswordLoader,		
                    path: "resetPassword",
                    element: < ResetPassword / > ,
                }					
			]
        },
        {
            element: < ProtectedRoute redirectPath={Routes.signIn} / >,
            errorElement: < Error / > ,
            children: [{
				id: "dashboard",
				path: "secureClient",
				element: <><IdleTimerWithPrompt idleUrl={Routes.signIn} timeout={40 * 60 * 1000} promptBeforeIdle={3 * 60 * 1000} />
				           <Dashboard mainMenuItems={mainMenuItems} />
				         </>,
				children: [{
                    path: "account",
                    loader: AccountLoader(auth, store),
                    element: < Account / > ,
                },
				{
                    path: "schedule",
                    loader: ScheduleLoader(auth, store),
                    element: < Schedule / > ,
                },
                {
                    path: "changePassword",
                    element: < ChangePassword / > ,
                }					
				]
			}],
        }
    ];
	

    const router = createHashRouter( 
		routeDefinitions, 
	    {
			future: {
				// Normalize `useNavigation()`/`useFetcher()` `formMethod` to uppercase
				v7_normalizeFormMethod: true,
			},
	    }
    );
    

    return (
        <RouterProvider router={router} />
    );
};



export { AppRouter, Routes };